"use strict";

exports.__esModule = true;
exports.default = void 0;

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin-bottom: ", ";\n\n\t@media (min-width: 20rem) {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\talign-items: center;\n\t}\n\n\t&:last-child {\n\t\tmargin-bottom: 0;\n\t}\n\n\t> label {\n\t\tflex: 1 0 12rem;\n\t\tpadding: 0 ", " 0 0 !important;\n\t\tmax-width: ", ";\n\t}\n\n\t> label + * {\n\t\tflex: 1 0 15rem;\n\t\tmax-width: ", ";\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Fieldset = _styledComponents.default.div(_templateObject(), _spacing.default.s1, _spacing.default.s2, function (props) {
  return props.maxLabelWidth;
}, function (props) {
  return props.maxContentWidth;
});

Fieldset.displayName = 'Fieldset';
Fieldset.propTypes = {
  maxLabelWidth: _propTypes.string,
  maxContentWidth: _propTypes.string
};
Fieldset.defaultProps = {
  maxLabelWidth: '14rem',
  maxContentWidth: '20rem'
};
/** @component */

var _default = Fieldset;
exports.default = _default;